/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       ResidentialImage.tsx
 * @author     Christian Ascone
 * @date       9/23/19 1:22 PM
 */

import React from 'react';
import {Image} from "react-native";

export function ResidentialImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../../assets/images/residential.png')
            }
        />
    );
}